import { render, staticRenderFns } from "./IconSecureLock.vue?vue&type=template&id=aaa22c62"
import script from "./IconSecureLock.vue?vue&type=script&lang=js"
export * from "./IconSecureLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports